<div class="flex flex-col justify-center items-center min-h-screen bg-gray-100">
  <div class="flex bg-white shadow-lg rounded-2xl overflow-hidden max-w-md w-full">
    <div class="flex flex-col w-full px-8 py-10 text-center gap-8">
      <div class="flex flex-col justify-between gap-3">
        <img [src]="branding.LOGO" [alt]="branding.APP_NAME" class="h-8 mx-auto" />
        <h1 class="text-2xl font-bold text-primary-dark">Recuperar Senha</h1>
        <p class="font-normal text-primary-gray">
          Insira seu endereço de e-mail e enviaremos instruções para redefinir sua senha.
        </p>
      </div>

      <form [formGroup]="recuperarSenhaForm" (ngSubmit)="onSubmit()">
        <div class="mb-4 text-left">
          <label for="email" class="input-label">
            E-mail
          </label>
          <div class="input-field"
            [ngClass]="{'input-field-error': recuperarSenhaForm.get('email')?.invalid && !emailFocused && recuperarSenhaForm.get('email')?.touched && recuperarSenhaForm.get('email')?.value, 'input-field-focus': !(recuperarSenhaForm.get('email')?.invalid && !emailFocused && recuperarSenhaForm.get('email')?.touched && recuperarSenhaForm.get('email')?.value)}">
            <mat-icon fontSet="material-icons-outlined" class="text-gray-500 small-icon">email</mat-icon>
            <input id="email" type="email" formControlName="email" placeholder="Insira o seu e-mail"
              class="input-element py-3" (focus)="emailFocused = true" (blur)="emailFocused = false" />
          </div>
          <div
            *ngIf="recuperarSenhaForm.get('email')?.invalid && !emailFocused && recuperarSenhaForm.get('email')?.touched && recuperarSenhaForm.get('email')?.value"
            class="text-red-500 text-sm mt-1">
            <div *ngIf="recuperarSenhaForm.get('email')?.errors?.['required']">E-mail é obrigatório.</div>
            <div *ngIf="recuperarSenhaForm.get('email')?.errors?.['email']">E-mail inválido.</div>
          </div>
        </div>
        <button type="submit" class="button-standard button-color-primary"
          [ngClass]="{'button-disabled': recuperarSenhaForm.invalid}" [disabled]="recuperarSenhaForm.invalid">
          <mat-icon class="mr-2 small-icon">send</mat-icon>
          Enviar link de recuperação
        </button>
        <button type="button" class="button-standard button-color-gray mt-4" (click)="navigateToLogin()">
          <mat-icon class="mr-2 small-icon">arrow_back</mat-icon>
          Voltar ao Login
        </button>
      </form>
    </div>
  </div>
</div>
